import React from "react";
import { Badge } from "react-bootstrap";

const MoneyBadge = ({ price }) => {
  return (
    <Badge bg="success" style={{ fontSize: "13px" }}>
      &#8377;{price}
    </Badge>
  );
};

export default MoneyBadge;
